export interface EmojiItem {
  emoji: string;
  name: string;
  keywords: string[];
}

export interface EmojiCategory {
  id: string;
  name: string;
  icon: string; // Icon representation
  emojis: EmojiItem[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys',
    name: 'Smileys & Emotion',
    icon: '😀',
    emojis: [
      { emoji: '😀', name: 'grinning face', keywords: ['happy', 'smile', 'joy', 'grin'] },
      { emoji: '😃', name: 'grinning face with big eyes', keywords: ['happy', 'joy', 'smile'] },
      { emoji: '😄', name: 'grinning face with smiling eyes', keywords: ['happy', 'joy', 'laugh'] },
      { emoji: '😁', name: 'beaming face with smiling eyes', keywords: ['grin', 'smile', 'happy'] },
      { emoji: '😆', name: 'grinning squinting face', keywords: ['laugh', 'lol', 'haha', 'happy'] },
      { emoji: '😅', name: 'grinning face with sweat', keywords: ['hot', 'relief', 'nervous', 'laugh'] },
      { emoji: '😂', name: 'face with tears of joy', keywords: ['lol', 'laugh', 'crying', 'tears', 'funny'] },
      { emoji: '🤣', name: 'rolling on the floor laughing', keywords: ['rofl', 'lol', 'laugh', 'funny'] },
      { emoji: '🥲', name: 'smiling face with tear', keywords: ['proud', 'relieved', 'grateful'] },
      { emoji: '🥹', name: 'face holding back tears', keywords: ['emotional', 'grateful', 'touched'] },
      { emoji: '☺️', name: 'smiling face', keywords: ['happy', 'warm', 'blush'] },
      { emoji: '😊', name: 'smiling face with smiling eyes', keywords: ['happy', 'blush', 'warm', 'smile'] },
      { emoji: '😇', name: 'smiling face with halo', keywords: ['angel', 'innocent', 'good'] },
      { emoji: '🙂', name: 'slightly smiling face', keywords: ['smile', 'polite', 'okay'] },
      { emoji: '🙃', name: 'upside-down face', keywords: ['sarcastic', 'silly', 'irony'] },
      { emoji: '😉', name: 'winking face', keywords: ['wink', 'flirt', 'joke'] },
      { emoji: '😌', name: 'relieved face', keywords: ['peaceful', 'calm', 'relax'] },
      { emoji: '😍', name: 'smiling face with heart-eyes', keywords: ['love', 'crush', 'heart', 'adore'] },
      { emoji: '🥰', name: 'smiling face with hearts', keywords: ['love', 'warm', 'affection'] },
      { emoji: '😘', name: 'face blowing a kiss', keywords: ['kiss', 'love', 'flirt'] },
      { emoji: '😗', name: 'kissing face', keywords: ['kiss', 'whistle'] },
      { emoji: '😙', name: 'kissing face with smiling eyes', keywords: ['kiss', 'smile'] },
      { emoji: '😚', name: 'kissing face with closed eyes', keywords: ['kiss', 'sweet'] },
      { emoji: '😋', name: 'face savoring food', keywords: ['yum', 'delicious', 'tasty', 'tongue'] },
      { emoji: '😛', name: 'face with tongue', keywords: ['silly', 'playful'] },
      { emoji: '😜', name: 'winking face with tongue', keywords: ['silly', 'crazy', 'party', 'wink'] },
      { emoji: '🤪', name: 'zany face', keywords: ['crazy', 'wild', 'goofy'] },
      { emoji: '😝', name: 'squinting face with tongue', keywords: ['prank', 'playful', 'silly'] },
      { emoji: '🤑', name: 'money-mouth face', keywords: ['money', 'rich', 'dollar', 'cash'] },
      { emoji: '🤗', name: 'smiling face with open hands', keywords: ['hug', 'welcome', 'warm'] },
      { emoji: '🤭', name: 'face with hand over mouth', keywords: ['giggle', 'secret', 'oops'] },
      { emoji: '🫢', name: 'face with open eyes and hand over mouth', keywords: ['shock', 'gasp', 'surprise'] },
      { emoji: '🫣', name: 'face with peeking eye', keywords: ['scared', 'shy', 'peeking'] },
      { emoji: '🤫', name: 'shushing face', keywords: ['quiet', 'secret', 'silent'] },
      { emoji: '🤔', name: 'thinking face', keywords: ['think', 'ponder', 'wonder', 'curious'] },
      { emoji: '🫡', name: 'saluting face', keywords: ['salute', 'respect', 'yes sir'] },
      { emoji: '🤐', name: 'zipper-mouth face', keywords: ['secret', 'silent', 'zip'] },
      { emoji: '🤨', name: 'face with raised eyebrow', keywords: ['skeptical', 'suspicious', 'doubt'] },
      { emoji: '😐', name: 'neutral face', keywords: ['meh', 'neutral', 'straight'] },
      { emoji: '😑', name: 'expressionless face', keywords: ['bored', 'blank', 'indifferent'] },
      { emoji: '😶', name: 'face without mouth', keywords: ['silent', 'speechless'] },
      { emoji: '🫥', name: 'dotted line face', keywords: ['invisible', 'disappear', 'introvert'] },
      { emoji: '😶‍🌫️', name: 'face in clouds', keywords: ['foggy', 'head in clouds', 'lost'] },
      { emoji: '😏', name: 'smirking face', keywords: ['smirk', 'flirt', 'clever'] },
      { emoji: '😒', name: 'unamused face', keywords: ['annoyed', 'grumpy', 'bored'] },
      { emoji: '🙄', name: 'face with rolling eyes', keywords: ['eyeroll', 'whatever', 'annoyed'] },
      { emoji: '😬', name: 'grimacing face', keywords: ['awkward', 'cringe', 'eek'] },
      { emoji: '😮‍💨', name: 'face exhaling', keywords: ['sigh', 'relief', 'tired'] },
      { emoji: '🤥', name: 'lying face', keywords: ['pinocchio', 'lie', 'dishonest'] },
      { emoji: '🫨', name: 'shaking face', keywords: ['shock', 'earthquake', 'vibrate'] },
      { emoji: '😌', name: 'relieved face', keywords: ['peace', 'relief', 'zen'] },
      { emoji: '😔', name: 'pensive face', keywords: ['sad', 'disappointed', 'gloomy'] },
      { emoji: '😪', name: 'sleepy face', keywords: ['tired', 'sleep', 'rest'] },
      { emoji: '🤤', name: 'drooling face', keywords: ['hungry', 'sleepy', 'drool'] },
      { emoji: '😴', name: 'sleeping face', keywords: ['sleep', 'zzz', 'night'] },
      { emoji: '😷', name: 'face with medical mask', keywords: ['sick', 'mask', 'covid', 'health'] },
      { emoji: '🤒', name: 'face with thermometer', keywords: ['sick', 'fever', 'ill'] },
      { emoji: '🤕', name: 'face with head-bandage', keywords: ['hurt', 'injured', 'ouch'] },
      { emoji: '🤢', name: 'nauseated face', keywords: ['gross', 'sick', 'disgusted'] },
      { emoji: '🤮', name: 'face vomiting', keywords: ['gross', 'puke', 'vomit'] },
      { emoji: '🤧', name: 'sneezing face', keywords: ['sneeze', 'cold', 'sick'] },
      { emoji: '🥵', name: 'hot face', keywords: ['heat', 'summer', 'sweat', 'hot'] },
      { emoji: '🥶', name: 'cold face', keywords: ['freeze', 'winter', 'ice', 'cold'] },
      { emoji: '🥴', name: 'woozy face', keywords: ['dizzy', 'drunk', 'tired'] },
      { emoji: '😵', name: 'knocked-out face', keywords: ['dead', 'dizzy', 'confused'] },
      { emoji: '😵‍💫', name: 'face with spiral eyes', keywords: ['hypnotized', 'dizzy', 'overwhelmed'] },
      { emoji: '🤯', name: 'exploding head', keywords: ['mindblown', 'shock', 'boom', 'wow'] },
      { emoji: '🤠', name: 'cowboy hat face', keywords: ['cowboy', 'country', 'yeehaw'] },
      { emoji: '🥳', name: 'partying face', keywords: ['party', 'celebrate', 'birthday', 'yay'] },
      { emoji: '🥸', name: 'disguised face', keywords: ['disguise', 'incognito', 'glasses'] },
      { emoji: '😎', name: 'smiling face with sunglasses', keywords: ['cool', 'sun', 'awesome', 'sunglasses'] },
      { emoji: '🤓', name: 'nerd face', keywords: ['geek', 'smart', 'glasses', 'nerd'] },
      { emoji: '🧐', name: 'face with monocle', keywords: ['curious', 'investigate', 'monocle'] },
      { emoji: '😕', name: 'confused face', keywords: ['confused', 'puzzled', 'doubt'] },
      { emoji: '🫤', name: 'face with diagonal mouth', keywords: ['meh', 'skeptical', 'unsure'] },
      { emoji: '😟', name: 'worried face', keywords: ['worry', 'concern', 'anxious'] },
      { emoji: '🙁', name: 'slightly frowning face', keywords: ['sad', 'frown'] },
      { emoji: '☹️', name: 'frowning face', keywords: ['sad', 'disappointed'] },
      { emoji: '😮', name: 'face with open mouth', keywords: ['gasp', 'surprise', 'wow'] },
      { emoji: '😯', name: 'hushed face', keywords: ['quiet', 'surprise', 'shock'] },
      { emoji: '😲', name: 'astonished face', keywords: ['shocked', 'wow', 'stunned'] },
      { emoji: '😳', name: 'flushed face', keywords: ['blush', 'embarrassed', 'shy'] },
      { emoji: '🥺', name: 'pleading face', keywords: ['puppy eyes', 'begging', 'cute', 'please'] },
      { emoji: '🥹', name: 'face holding back tears', keywords: ['tears', 'emotional'] },
      { emoji: '😦', name: 'frowning face with open mouth', keywords: ['sad', 'upset'] },
      { emoji: '😧', name: 'anguished face', keywords: ['stunned', 'shocked'] },
      { emoji: '😨', name: 'fearful face', keywords: ['scared', 'afraid', 'fear'] },
      { emoji: '😰', name: 'anxious face with sweat', keywords: ['nervous', 'anxious', 'worried'] },
      { emoji: '😥', name: 'sad but relieved face', keywords: ['sad', 'phew', 'relieved'] },
      { emoji: '😢', name: 'crying face', keywords: ['sad', 'tear', 'cry', 'upset'] },
      { emoji: '😭', name: 'loudly crying face', keywords: ['sob', 'cry', 'bawl', 'tears', 'sad'] },
      { emoji: '😱', name: 'face screaming in fear', keywords: ['scared', 'scream', 'fear', 'shock'] },
      { emoji: '😖', name: 'confounded face', keywords: ['upset', 'confused', 'frustrated'] },
      { emoji: '😣', name: 'persevering face', keywords: ['struggle', 'try', 'effort'] },
      { emoji: '😞', name: 'disappointed face', keywords: ['sad', 'down', 'blue'] },
      { emoji: '😓', name: 'downcast face with sweat', keywords: ['exhausted', 'hard work'] },
      { emoji: '😩', name: 'weary face', keywords: ['tired', 'frustrated', 'exhausted'] },
      { emoji: '😫', name: 'tired face', keywords: ['exhausted', 'sleepy'] },
      { emoji: '🥱', name: 'yawning face', keywords: ['yawn', 'sleepy', 'bored'] },
      { emoji: '😤', name: 'face with steam from nose', keywords: ['triumph', 'angry', 'determined'] },
      { emoji: '😡', name: 'enraged face', keywords: ['angry', 'mad', 'rage'] },
      { emoji: '😠', name: 'angry face', keywords: ['mad', 'furious', 'grumpy'] },
      { emoji: '🤬', name: 'face with symbols on mouth', keywords: ['curse', 'swear', 'angry', 'furious'] },
      { emoji: '😈', name: 'smiling face with horns', keywords: ['devil', 'evil', 'naughty'] },
      { emoji: '👿', name: 'angry face with horns', keywords: ['devil', 'evil', 'rage'] },
      { emoji: '💀', name: 'skull', keywords: ['dead', 'skeleton', 'death', 'danger'] },
      { emoji: '☠️', name: 'skull and crossbones', keywords: ['pirate', 'danger', 'deadly'] },
      { emoji: '💩', name: 'pile of poo', keywords: ['poop', 'crap', 'funny'] },
      { emoji: '🤡', name: 'clown face', keywords: ['clown', 'fool', 'joke'] },
      { emoji: '👹', name: 'ogre', keywords: ['monster', 'demon', 'japanese'] },
      { emoji: '👺', name: 'goblin', keywords: ['mask', 'tengu'] },
      { emoji: '👻', name: 'ghost', keywords: ['halloween', 'spooky', 'boo'] },
      { emoji: '👽', name: 'alien', keywords: ['ufo', 'space', 'extraterrestrial'] },
      { emoji: '👾', name: 'alien monster', keywords: ['game', 'arcade', 'retro'] },
      { emoji: '🤖', name: 'robot', keywords: ['bot', 'ai', 'tech'] },
      { emoji: '😺', name: 'grinning cat', keywords: ['cat', 'smile'] },
      { emoji: '😸', name: 'grinning cat with smiling eyes', keywords: ['cat', 'happy'] },
      { emoji: '😹', name: 'cat with tears of joy', keywords: ['cat', 'lol', 'laugh'] },
      { emoji: '😻', name: 'smiling cat with heart-eyes', keywords: ['cat', 'love'] },
      { emoji: '😼', name: 'cat with wry smile', keywords: ['cat', 'smirk'] },
      { emoji: '😽', name: 'kissing cat', keywords: ['cat', 'kiss'] },
      { emoji: '🙀', name: 'weary cat', keywords: ['cat', 'scared', 'omg'] },
      { emoji: '😿', name: 'crying cat', keywords: ['cat', 'sad'] },
      { emoji: '😾', name: 'pouting cat', keywords: ['cat', 'angry'] },
      { emoji: '🙈', name: 'see-no-evil monkey', keywords: ['monkey', 'blind', 'shy'] },
      { emoji: '🙉', name: 'hear-no-evil monkey', keywords: ['monkey', 'deaf'] },
      { emoji: '🙊', name: 'speak-no-evil monkey', keywords: ['monkey', 'silent', 'mute'] },
    ],
  },
  {
    id: 'people',
    name: 'People & Body',
    icon: '👋',
    emojis: [
      { emoji: '👋', name: 'waving hand', keywords: ['hello', 'hi', 'bye', 'wave'] },
      { emoji: '🤚', name: 'raised back of hand', keywords: ['backhand', 'stop'] },
      { emoji: '🖐️', name: 'hand with fingers splayed', keywords: ['five', 'high five'] },
      { emoji: '✋', name: 'raised hand', keywords: ['stop', 'high five', 'halt'] },
      { emoji: '🖖', name: 'vulcan salute', keywords: ['spock', 'star trek', 'live long'] },
      { emoji: '🫱', name: 'rightwards hand', keywords: ['hand', 'reach'] },
      { emoji: '🫲', name: 'leftwards hand', keywords: ['hand', 'reach'] },
      { emoji: '🫳', name: 'palm down hand', keywords: ['drop', 'hand'] },
      { emoji: '🫴', name: 'palm up hand', keywords: ['offer', 'catch'] },
      { emoji: '👌', name: 'OK hand', keywords: ['ok', 'perfect', 'agree', 'fine'] },
      { emoji: '🤌', name: 'pinched fingers', keywords: ['italian', 'chef kiss', 'what'] },
      { emoji: '🤏', name: 'pinching hand', keywords: ['small', 'little', 'tiny'] },
      { emoji: '✌️', name: 'victory hand', keywords: ['peace', 'victory', 'two'] },
      { emoji: '🤞', name: 'crossed fingers', keywords: ['luck', 'hope', 'wish'] },
      { emoji: '🫰', name: 'hand with index finger and thumb crossed', keywords: ['kpop', 'finger heart', 'money'] },
      { emoji: '🤟', name: 'love-you gesture', keywords: ['love', 'rock'] },
      { emoji: '🤘', name: 'sign of the horns', keywords: ['rock', 'metal', 'horns'] },
      { emoji: '🤙', name: 'call me hand', keywords: ['shaka', 'hang loose', 'call'] },
      { emoji: '👈', name: 'backhand index pointing left', keywords: ['left', 'point'] },
      { emoji: '👉', name: 'backhand index pointing right', keywords: ['right', 'point'] },
      { emoji: '👆', name: 'backhand index pointing up', keywords: ['up', 'point'] },
      { emoji: '🖕', name: 'middle finger', keywords: ['rude', 'finger'] },
      { emoji: '👇', name: 'backhand index pointing down', keywords: ['down', 'point'] },
      { emoji: '☝️', name: 'index pointing up', keywords: ['first', 'point', 'up'] },
      { emoji: '🫵', name: 'index pointing at the viewer', keywords: ['you', 'point'] },
      { emoji: '👍', name: 'thumbs up', keywords: ['yes', 'like', 'approve', 'agree', 'good'] },
      { emoji: '👎', name: 'thumbs down', keywords: ['no', 'dislike', 'bad'] },
      { emoji: '✊', name: 'raised fist', keywords: ['power', 'fist'] },
      { emoji: '👊', name: 'oncoming fist', keywords: ['punch', 'fist bump'] },
      { emoji: '🤛', name: 'left-facing fist', keywords: ['fist bump'] },
      { emoji: '🤜', name: 'right-facing fist', keywords: ['fist bump'] },
      { emoji: '👏', name: 'clapping hands', keywords: ['applause', 'bravo', 'clap'] },
      { emoji: '🙌', name: 'raising hands', keywords: ['celebrate', 'praise', 'hooray'] },
      { emoji: '🫶', name: 'heart hands', keywords: ['love', 'heart', 'care'] },
      { emoji: '👐', name: 'open hands', keywords: ['open', 'hug'] },
      { emoji: '🤲', name: 'palms up together', keywords: ['prayer', 'duas'] },
      { emoji: '🤝', name: 'handshake', keywords: ['deal', 'agree', 'partnership', 'hello'] },
      { emoji: '🙏', name: 'folded hands', keywords: ['pray', 'please', 'thank you', 'namaste'] },
      { emoji: '✍️', name: 'writing hand', keywords: ['write', 'author', 'pen'] },
      { emoji: '💅', name: 'nail polish', keywords: ['care', 'slay', 'beauty'] },
      { emoji: '🤳', name: 'selfie', keywords: ['camera', 'phone', 'photo'] },
      { emoji: '💪', name: 'flexed biceps', keywords: ['strong', 'muscle', 'gym', 'workout'] },
      { emoji: '🦾', name: 'mechanical arm', keywords: ['prosthetic', 'robot'] },
      { emoji: '🦿', name: 'mechanical leg', keywords: ['prosthetic', 'robot'] },
      { emoji: '🦵', name: 'leg', keywords: ['kick', 'body'] },
      { emoji: '🦶', name: 'foot', keywords: ['kick', 'walk'] },
      { emoji: '👂', name: 'ear', keywords: ['listen', 'hear'] },
      { emoji: '🦻', name: 'ear with hearing aid', keywords: ['accessibility'] },
      { emoji: '👃', name: 'nose', keywords: ['smell', 'sniff'] },
      { emoji: '🧠', name: 'brain', keywords: ['smart', 'intellect', 'think'] },
      { emoji: '🫀', name: 'anatomical heart', keywords: ['heart', 'cardiology'] },
      { emoji: '🫁', name: 'lungs', keywords: ['breath', 'organ'] },
      { emoji: '🦷', name: 'tooth', keywords: ['dentist', 'teeth'] },
      { emoji: '🦴', name: 'bone', keywords: ['skeleton'] },
      { emoji: '👀', name: 'eyes', keywords: ['look', 'see', 'watch', 'peek'] },
      { emoji: '👁️', name: 'eye', keywords: ['vision', 'look'] },
      { emoji: '👅', name: 'tongue', keywords: ['taste', 'lick'] },
      { emoji: '👄', name: 'mouth', keywords: ['lips', 'kiss'] },
      { emoji: '🫦', name: 'biting lip', keywords: ['flirt', 'nervous'] },
      { emoji: '👶', name: 'baby', keywords: ['child', 'infant'] },
      { emoji: '🧒', name: 'child', keywords: ['kid', 'young'] },
      { emoji: '👦', name: 'boy', keywords: ['male', 'kid'] },
      { emoji: '👧', name: 'girl', keywords: ['female', 'kid'] },
      { emoji: '🧑', name: 'person', keywords: ['human', 'adult'] },
      { emoji: '👱', name: 'person: blond hair', keywords: ['blond'] },
      { emoji: '👨', name: 'man', keywords: ['male', 'adult'] },
      { emoji: '🧔', name: 'person: beard', keywords: ['beard', 'facial hair'] },
      { emoji: '👩', name: 'woman', keywords: ['female', 'adult'] },
      { emoji: '🧓', name: 'older person', keywords: ['elder', 'senior'] },
      { emoji: '👴', name: 'old man', keywords: ['grandpa', 'senior'] },
      { emoji: '👵', name: 'old woman', keywords: ['grandma', 'senior'] },
    ],
  },
  {
    id: 'nature',
    name: 'Animals & Nature',
    icon: '🐶',
    emojis: [
      { emoji: '🐶', name: 'dog face', keywords: ['dog', 'puppy', 'pet'] },
      { emoji: '🐱', name: 'cat face', keywords: ['cat', 'kitten', 'pet'] },
      { emoji: '🐭', name: 'mouse face', keywords: ['mouse', 'rodent'] },
      { emoji: '🐹', name: 'hamster', keywords: ['hamster', 'pet'] },
      { emoji: '🐰', name: 'rabbit face', keywords: ['bunny', 'rabbit'] },
      { emoji: '🦊', name: 'fox', keywords: ['fox', 'wild'] },
      { emoji: '🐻', name: 'bear', keywords: ['bear', 'wild'] },
      { emoji: '🐼', name: 'panda', keywords: ['panda', 'bear'] },
      { emoji: '🐻‍❄️', name: 'polar bear', keywords: ['arctic', 'bear'] },
      { emoji: '🐨', name: 'koala', keywords: ['australia', 'koala'] },
      { emoji: '🐯', name: 'tiger face', keywords: ['tiger', 'wild', 'cat'] },
      { emoji: '🦁', name: 'lion', keywords: ['lion', 'king', 'wild'] },
      { emoji: '🐮', name: 'cow face', keywords: ['cow', 'farm', 'milk'] },
      { emoji: '🐷', name: 'pig face', keywords: ['pig', 'farm'] },
      { emoji: '🐽', name: 'pig nose', keywords: ['pig', 'snout'] },
      { emoji: '🐸', name: 'frog', keywords: ['frog', 'amphibian'] },
      { emoji: '🐵', name: 'monkey face', keywords: ['monkey', 'ape'] },
      { emoji: '🐔', name: 'chicken', keywords: ['chicken', 'bird', 'farm'] },
      { emoji: '🐧', name: 'penguin', keywords: ['penguin', 'bird', 'cold'] },
      { emoji: '🐦', name: 'bird', keywords: ['bird', 'fly'] },
      { emoji: '🐤', name: 'baby chick', keywords: ['chick', 'bird'] },
      { emoji: '🦆', name: 'duck', keywords: ['duck', 'bird', 'quack'] },
      { emoji: '🦅', name: 'eagle', keywords: ['eagle', 'bird', 'usa'] },
      { emoji: '🦉', name: 'owl', keywords: ['owl', 'wise', 'bird'] },
      { emoji: '🦇', name: 'bat', keywords: ['bat', 'spooky'] },
      { emoji: '🐺', name: 'wolf', keywords: ['wolf', 'wild', 'howl'] },
      { emoji: '🐗', name: 'boar', keywords: ['wild pig'] },
      { emoji: '🐴', name: 'horse face', keywords: ['horse', 'farm'] },
      { emoji: '🦄', name: 'unicorn', keywords: ['magic', 'unicorn', 'fantasy'] },
      { emoji: '🐝', name: 'honeybee', keywords: ['bee', 'honey', 'insect'] },
      { emoji: '🐛', name: 'bug', keywords: ['caterpillar', 'insect'] },
      { emoji: '🦋', name: 'butterfly', keywords: ['butterfly', 'insect', 'pretty'] },
      { emoji: '🐌', name: 'snail', keywords: ['snail', 'slow'] },
      { emoji: '🐞', name: 'lady beetle', keywords: ['ladybug', 'insect'] },
      { emoji: '🐜', name: 'ant', keywords: ['ant', 'insect'] },
      { emoji: '🪰', name: 'fly', keywords: ['fly', 'insect'] },
      { emoji: '🪲', name: 'beetle', keywords: ['bug', 'insect'] },
      { emoji: '🕷️', name: 'spider', keywords: ['spider', 'web', 'spooky'] },
      { emoji: '🦂', name: 'scorpion', keywords: ['scorpion', 'sting'] },
      { emoji: '🐢', name: 'turtle', keywords: ['turtle', 'slow', 'reptile'] },
      { emoji: '🐍', name: 'snake', keywords: ['snake', 'reptile'] },
      { emoji: '🦎', name: 'lizard', keywords: ['lizard', 'reptile'] },
      { emoji: '🦖', name: 'T-Rex', keywords: ['dinosaur', 'trex', 'jurassic'] },
      { emoji: '🦕', name: 'sauropod', keywords: ['dinosaur', 'herbivore'] },
      { emoji: '🐙', name: 'octopus', keywords: ['octopus', 'sea'] },
      { emoji: '🦑', name: 'squid', keywords: ['squid', 'sea'] },
      { emoji: '🦐', name: 'shrimp', keywords: ['shrimp', 'seafood'] },
      { emoji: '🦞', name: 'lobster', keywords: ['lobster', 'seafood'] },
      { emoji: '🦀', name: 'crab', keywords: ['crab', 'beach'] },
      { emoji: '🐡', name: 'blowfish', keywords: ['fish', 'ocean'] },
      { emoji: '🐠', name: 'tropical fish', keywords: ['fish', 'sea'] },
      { emoji: '🐟', name: 'fish', keywords: ['fish', 'sea'] },
      { emoji: '🐬', name: 'dolphin', keywords: ['dolphin', 'sea'] },
      { emoji: '🐳', name: 'spouting whale', keywords: ['whale', 'sea'] },
      { emoji: '🐋', name: 'whale', keywords: ['whale', 'ocean'] },
      { emoji: '🦈', name: 'shark', keywords: ['shark', 'ocean', 'danger'] },
      { emoji: '🦭', name: 'seal', keywords: ['seal', 'sea'] },
      { emoji: '🐊', name: 'crocodile', keywords: ['crocodile', 'alligator'] },
      { emoji: '🐅', name: 'tiger', keywords: ['tiger', 'wild'] },
      { emoji: '🐆', name: 'leopard', keywords: ['leopard', 'cat'] },
      { emoji: '🦓', name: 'zebra', keywords: ['zebra', 'stripes'] },
      { emoji: '🦍', name: 'gorilla', keywords: ['gorilla', 'ape'] },
      { emoji: '🦧', name: 'orangutan', keywords: ['ape', 'monkey'] },
      { emoji: '🐘', name: 'elephant', keywords: ['elephant', 'trunk'] },
      { emoji: '🦛', name: 'hippopotamus', keywords: ['hippo'] },
      { emoji: '🦏', name: 'rhinoceros', keywords: ['rhino'] },
      { emoji: '🐪', name: 'camel', keywords: ['camel', 'desert'] },
      { emoji: '🐫', name: 'two-hump camel', keywords: ['camel', 'desert'] },
      { emoji: '🦒', name: 'giraffe', keywords: ['giraffe', 'tall'] },
      { emoji: '🦘', name: 'kangaroo', keywords: ['kangaroo', 'australia'] },
      { emoji: '🦬', name: 'bison', keywords: ['bison', 'buffalo'] },
      { emoji: '🐃', name: 'water buffalo', keywords: ['buffalo'] },
      { emoji: '🐂', name: 'ox', keywords: ['ox', 'bull'] },
      { emoji: '🐄', name: 'cow', keywords: ['cow', 'farm'] },
      { emoji: '🐎', name: 'horse', keywords: ['horse', 'race'] },
      { emoji: '🐖', name: 'pig', keywords: ['pig', 'farm'] },
      { emoji: '🐏', name: 'ram', keywords: ['sheep', 'horns'] },
      { emoji: '🐑', name: 'ewe', keywords: ['sheep', 'wool'] },
      { emoji: '🦙', name: 'llama', keywords: ['llama', 'alpaca'] },
      { emoji: '🐐', name: 'goat', keywords: ['goat', 'farm'] },
      { emoji: '🦌', name: 'deer', keywords: ['deer', 'stag'] },
      { emoji: '🐕', name: 'dog', keywords: ['dog', 'pet'] },
      { emoji: '🐩', name: 'poodle', keywords: ['dog', 'poodle'] },
      { emoji: '🦮', name: 'guide dog', keywords: ['service dog'] },
      { emoji: '🐕‍🦺', name: 'service dog', keywords: ['service dog'] },
      { emoji: '🐈', name: 'cat', keywords: ['cat', 'pet'] },
      { emoji: '🐈‍⬛', name: 'black cat', keywords: ['black cat', 'halloween'] },
      { emoji: '🪶', name: 'feather', keywords: ['feather', 'bird'] },
      { emoji: '🐓', name: 'rooster', keywords: ['rooster', 'chicken'] },
      { emoji: '🦃', name: 'turkey', keywords: ['turkey', 'thanksgiving'] },
      { emoji: '🦚', name: 'peacock', keywords: ['peacock', 'bird'] },
      { emoji: '🦜', name: 'parrot', keywords: ['parrot', 'bird'] },
      { emoji: '🦢', name: 'swan', keywords: ['swan', 'bird'] },
      { emoji: '🦩', name: 'flamingo', keywords: ['flamingo', 'pink'] },
      { emoji: '🕊️', name: 'dove', keywords: ['peace', 'dove', 'bird'] },
      { emoji: '🐇', name: 'rabbit', keywords: ['bunny', 'rabbit'] },
      { emoji: '🦝', name: 'raccoon', keywords: ['raccoon', 'bandit'] },
      { emoji: '🦨', name: 'skunk', keywords: ['skunk', 'smell'] },
      { emoji: '🦡', name: 'badger', keywords: ['badger'] },
      { emoji: '🦫', name: 'beaver', keywords: ['beaver', 'dam'] },
      { emoji: '🦦', name: 'otter', keywords: ['otter', 'cute'] },
      { emoji: '🦥', name: 'sloth', keywords: ['sloth', 'lazy'] },
      { emoji: '🐁', name: 'mouse', keywords: ['mouse'] },
      { emoji: '🐀', name: 'rat', keywords: ['rat'] },
      { emoji: '🐿️', name: 'chipmunk', keywords: ['squirrel', 'nuts'] },
      { emoji: '🦔', name: 'hedgehog', keywords: ['hedgehog', 'spikes'] },
      { emoji: '🌸', name: 'cherry blossom', keywords: ['flower', 'pink', 'spring', 'sakura'] },
      { emoji: '💮', name: 'white flower', keywords: ['flower'] },
      { emoji: '🏵️', name: 'rosette', keywords: ['flower'] },
      { emoji: '🌹', name: 'rose', keywords: ['flower', 'red', 'love'] },
      { emoji: '🥀', name: 'wilted flower', keywords: ['sad', 'dead flower'] },
      { emoji: '🌺', name: 'hibiscus', keywords: ['flower', 'tropical'] },
      { emoji: '🌻', name: 'sunflower', keywords: ['flower', 'sun', 'yellow'] },
      { emoji: '🌼', name: 'blossom', keywords: ['flower', 'spring'] },
      { emoji: '🌷', name: 'tulip', keywords: ['flower', 'spring'] },
      { emoji: '🌱', name: 'seedling', keywords: ['plant', 'sprout', 'growth'] },
      { emoji: '🪴', name: 'potted plant', keywords: ['plant', 'houseplant'] },
      { emoji: '🌲', name: 'evergreen tree', keywords: ['tree', 'forest', 'pine'] },
      { emoji: '🌳', name: 'deciduous tree', keywords: ['tree', 'nature'] },
      { emoji: '🌴', name: 'palm tree', keywords: ['tree', 'beach', 'tropical'] },
      { emoji: '🌵', name: 'cactus', keywords: ['cactus', 'desert'] },
      { emoji: '🌾', name: 'sheaf of rice', keywords: ['rice', 'grain'] },
      { emoji: '🌿', name: 'herb', keywords: ['leaf', 'nature'] },
      { emoji: '☘️', name: 'shamrock', keywords: ['shamrock', 'clover', 'irish'] },
      { emoji: '🍀', name: 'four leaf clover', keywords: ['luck', 'clover', 'lucky'] },
      { emoji: '🍁', name: 'maple leaf', keywords: ['leaf', 'fall', 'canada', 'autumn'] },
      { emoji: '🍂', name: 'fallen leaf', keywords: ['leaf', 'autumn', 'fall'] },
      { emoji: '🍃', name: 'leaf fluttering in wind', keywords: ['leaf', 'wind', 'nature'] },
      { emoji: '🍄', name: 'mushroom', keywords: ['mushroom', 'fungus'] },
      { emoji: '🌰', name: 'chestnut', keywords: ['chestnut', 'nut'] },
    ],
  },
  {
    id: 'food',
    name: 'Food & Drink',
    icon: '🍕',
    emojis: [
      { emoji: '🍏', name: 'green apple', keywords: ['apple', 'fruit'] },
      { emoji: '🍎', name: 'red apple', keywords: ['apple', 'fruit'] },
      { emoji: '🍐', name: 'pear', keywords: ['pear', 'fruit'] },
      { emoji: '🍊', name: 'tangerine', keywords: ['orange', 'citrus', 'fruit'] },
      { emoji: '🍋', name: 'lemon', keywords: ['lemon', 'sour', 'citrus'] },
      { emoji: '🍌', name: 'banana', keywords: ['banana', 'fruit'] },
      { emoji: '🍉', name: 'watermelon', keywords: ['watermelon', 'summer', 'fruit'] },
      { emoji: '🍇', name: 'grapes', keywords: ['grapes', 'fruit', 'wine'] },
      { emoji: '🍓', name: 'strawberry', keywords: ['strawberry', 'berry', 'fruit'] },
      { emoji: '🫐', name: 'blueberries', keywords: ['berry', 'fruit'] },
      { emoji: '🍈', name: 'melon', keywords: ['melon', 'fruit'] },
      { emoji: '🍒', name: 'cherries', keywords: ['cherry', 'fruit'] },
      { emoji: '🍑', name: 'peach', keywords: ['peach', 'fruit'] },
      { emoji: '🥭', name: 'mango', keywords: ['mango', 'fruit', 'tropical'] },
      { emoji: '🍍', name: 'pineapple', keywords: ['pineapple', 'fruit'] },
      { emoji: '🥥', name: 'coconut', keywords: ['coconut', 'tropical'] },
      { emoji: '🥝', name: 'kiwi fruit', keywords: ['kiwi', 'fruit'] },
      { emoji: '🍅', name: 'tomato', keywords: ['tomato', 'vegetable'] },
      { emoji: '🥑', name: 'avocado', keywords: ['avocado', 'guacamole'] },
      { emoji: '🥦', name: 'broccoli', keywords: ['broccoli', 'healthy'] },
      { emoji: '🥬', name: 'leafy green', keywords: ['salad', 'lettuce'] },
      { emoji: '🥒', name: 'cucumber', keywords: ['pickle', 'cucumber'] },
      { emoji: '🌶️', name: 'hot pepper', keywords: ['spicy', 'chili', 'hot'] },
      { emoji: '🫑', name: 'bell pepper', keywords: ['pepper', 'paprika'] },
      { emoji: '🌽', name: 'ear of corn', keywords: ['corn', 'maize'] },
      { emoji: '🥕', name: 'carrot', keywords: ['carrot', 'vegetable'] },
      { emoji: '🫒', name: 'olive', keywords: ['olive'] },
      { emoji: '🧄', name: 'garlic', keywords: ['garlic', 'cooking'] },
      { emoji: '🧅', name: 'onion', keywords: ['onion'] },
      { emoji: '🥔', name: 'potato', keywords: ['potato', 'fries'] },
      { emoji: '🍠', name: 'roasted sweet potato', keywords: ['sweet potato'] },
      { emoji: '🥐', name: 'croissant', keywords: ['croissant', 'bakery', 'french'] },
      { emoji: '🥯', name: 'bagel', keywords: ['bagel', 'bread'] },
      { emoji: '🍞', name: 'bread', keywords: ['bread', 'toast'] },
      { emoji: '🥖', name: 'baguette bread', keywords: ['french bread'] },
      { emoji: '🥨', name: 'pretzel', keywords: ['pretzel', 'snack'] },
      { emoji: '🧀', name: 'cheese wedge', keywords: ['cheese'] },
      { emoji: '🥚', name: 'egg', keywords: ['egg', 'breakfast'] },
      { emoji: '🍳', name: 'cooking', keywords: ['egg', 'fry', 'breakfast'] },
      { emoji: '🧈', name: 'butter', keywords: ['butter', 'dairy'] },
      { emoji: '🥞', name: 'pancakes', keywords: ['pancake', 'breakfast'] },
      { emoji: '🧇', name: 'waffle', keywords: ['waffle', 'breakfast'] },
      { emoji: '🥓', name: 'bacon', keywords: ['bacon', 'meat', 'breakfast'] },
      { emoji: '🥩', name: 'cut of meat', keywords: ['steak', 'meat', 'beef'] },
      { emoji: '🍗', name: 'poultry leg', keywords: ['chicken', 'drumstick', 'meat'] },
      { emoji: '🍖', name: 'meat on bone', keywords: ['meat', 'bone'] },
      { emoji: '🌭', name: 'hot dog', keywords: ['hotdog', 'fast food'] },
      { emoji: '🍔', name: 'hamburger', keywords: ['burger', 'fast food', 'cheeseburger'] },
      { emoji: '🍟', name: 'french fries', keywords: ['fries', 'fast food', 'chips'] },
      { emoji: '🍕', name: 'pizza', keywords: ['pizza', 'cheese', 'fast food', 'slice'] },
      { emoji: '🫓', name: 'flatbread', keywords: ['roti', 'naan', 'pita'] },
      { emoji: '🥪', name: 'sandwich', keywords: ['sandwich', 'lunch'] },
      { emoji: '🥙', name: 'stuffed flatbread', keywords: ['shawarma', 'falafel', 'gyro'] },
      { emoji: '🧆', name: 'falafel', keywords: ['falafel', 'chickpea'] },
      { emoji: '🌮', name: 'taco', keywords: ['taco', 'mexican'] },
      { emoji: '🌯', name: 'burrito', keywords: ['burrito', 'wrap'] },
      { emoji: '🫔', name: 'tamale', keywords: ['tamale'] },
      { emoji: '🥗', name: 'green salad', keywords: ['salad', 'healthy'] },
      { emoji: '🥘', name: 'shallow pan of food', keywords: ['paella', 'curry'] },
      { emoji: '🫕', name: 'fondue', keywords: ['fondue', 'cheese'] },
      { emoji: '🥫', name: 'canned food', keywords: ['can', 'soup'] },
      { emoji: '🍝', name: 'spaghetti', keywords: ['pasta', 'noodle', 'italian'] },
      { emoji: '🍜', name: 'steaming bowl', keywords: ['ramen', 'noodles', 'soup'] },
      { emoji: '🍲', name: 'pot of food', keywords: ['stew', 'soup'] },
      { emoji: '🍛', name: 'curry rice', keywords: ['curry', 'rice', 'indian'] },
      { emoji: '🍣', name: 'sushi', keywords: ['sushi', 'japanese', 'fish'] },
      { emoji: '🍱', name: 'bento box', keywords: ['bento', 'lunch'] },
      { emoji: '🥟', name: 'dumpling', keywords: ['dumpling', 'dim sum'] },
      { emoji: '🦪', name: 'oyster', keywords: ['oyster', 'seafood'] },
      { emoji: '🍤', name: 'fried shrimp', keywords: ['shrimp', 'tempura'] },
      { emoji: '🍙', name: 'rice ball', keywords: ['onigiri', 'rice'] },
      { emoji: '🍚', name: 'cooked rice', keywords: ['rice', 'bowl'] },
      { emoji: '🍘', name: 'rice cracker', keywords: ['cracker', 'snack'] },
      { emoji: '🍥', name: 'fish cake with swirl', keywords: ['naruto', 'ramen'] },
      { emoji: '🥠', name: 'fortune cookie', keywords: ['fortune cookie'] },
      { emoji: '🥮', name: 'moon cake', keywords: ['mooncake'] },
      { emoji: '🍢', name: 'oden', keywords: ['oden', 'skewer'] },
      { emoji: '🍡', name: 'dango', keywords: ['dango', 'dessert'] },
      { emoji: '🍧', name: 'shaved ice', keywords: ['dessert', 'ice'] },
      { emoji: '🍨', name: 'ice cream', keywords: ['ice cream', 'dessert'] },
      { emoji: '🍦', name: 'soft ice cream', keywords: ['ice cream', 'cone', 'dessert'] },
      { emoji: '🥧', name: 'pie', keywords: ['pie', 'baking'] },
      { emoji: '🧁', name: 'cupcake', keywords: ['cupcake', 'cake', 'sweet'] },
      { emoji: '🍰', name: 'shortcake', keywords: ['cake', 'strawberry'] },
      { emoji: '🎂', name: 'birthday cake', keywords: ['birthday', 'cake', 'party', 'celebration'] },
      { emoji: '🍮', name: 'custard', keywords: ['pudding', 'dessert'] },
      { emoji: '🍭', name: 'lollipop', keywords: ['candy', 'sweet'] },
      { emoji: '🍬', name: 'candy', keywords: ['candy', 'sweet'] },
      { emoji: '🍫', name: 'chocolate bar', keywords: ['chocolate', 'sweet'] },
      { emoji: '🍿', name: 'popcorn', keywords: ['popcorn', 'movie', 'cinema'] },
      { emoji: '🍩', name: 'doughnut', keywords: ['donut', 'doughnut', 'sweet'] },
      { emoji: '🍪', name: 'cookie', keywords: ['cookie', 'chocolate chip', 'biscuit'] },
      { emoji: '🥜', name: 'peanuts', keywords: ['peanut', 'nut'] },
      { emoji: '🍯', name: 'honey pot', keywords: ['honey', 'sweet'] },
      { emoji: '🥛', name: 'glass of milk', keywords: ['milk', 'dairy'] },
      { emoji: '🍼', name: 'baby bottle', keywords: ['bottle', 'milk'] },
      { emoji: '🫖', name: 'teapot', keywords: ['tea', 'pot'] },
      { emoji: '☕', name: 'hot beverage', keywords: ['coffee', 'tea', 'cafe', 'latte', 'espresso'] },
      { emoji: '🍵', name: 'teacup without handle', keywords: ['matcha', 'green tea'] },
      { emoji: '🧃', name: 'beverage box', keywords: ['juice', 'box'] },
      { emoji: '🥤', name: 'cup with straw', keywords: ['soda', 'drink', 'cola'] },
      { emoji: '🧋', name: 'bubble tea', keywords: ['boba', 'bubble tea'] },
      { emoji: '🍶', name: 'sake', keywords: ['sake', 'alcohol'] },
      { emoji: '🍺', name: 'beer mug', keywords: ['beer', 'drink', 'pub', 'alcohol'] },
      { emoji: '🍻', name: 'clinking beer mugs', keywords: ['cheers', 'beer', 'celebrate'] },
      { emoji: '🥂', name: 'clinking glasses', keywords: ['cheers', 'champagne', 'celebration', 'toast'] },
      { emoji: '🍷', name: 'wine glass', keywords: ['wine', 'red wine', 'drink'] },
      { emoji: '🥃', name: 'tumbler glass', keywords: ['whiskey', 'liquor', 'bourbon'] },
      { emoji: '🍸', name: 'cocktail glass', keywords: ['martini', 'cocktail'] },
      { emoji: '🍹', name: 'tropical drink', keywords: ['cocktail', 'vacation'] },
      { emoji: '🧉', name: 'mate', keywords: ['mate', 'drink'] },
      { emoji: '🍾', name: 'bottle with popping cork', keywords: ['champagne', 'celebration', 'party'] },
      { emoji: '🧊', name: 'ice', keywords: ['ice cube', 'cold'] },
    ],
  },
  {
    id: 'travel',
    name: 'Travel & Places',
    icon: '✈️',
    emojis: [
      { emoji: '🚗', name: 'automobile', keywords: ['car', 'drive'] },
      { emoji: '🚕', name: 'taxi', keywords: ['taxi', 'cab'] },
      { emoji: '🚙', name: 'sport utility vehicle', keywords: ['suv', 'car'] },
      { emoji: '🚌', name: 'bus', keywords: ['bus', 'transit'] },
      { emoji: '🚎', name: 'trolleybus', keywords: ['trolley'] },
      { emoji: '🏎️', name: 'racing car', keywords: ['f1', 'racecar', 'fast'] },
      { emoji: '🚓', name: 'police car', keywords: ['police', 'cop'] },
      { emoji: '🚑', name: 'ambulance', keywords: ['emergency', 'hospital'] },
      { emoji: '🚒', name: 'fire engine', keywords: ['fire truck'] },
      { emoji: '🚐', name: 'minibus', keywords: ['van'] },
      { emoji: '🛻', name: 'pickup truck', keywords: ['truck'] },
      { emoji: '🚚', name: 'delivery truck', keywords: ['delivery', 'shipping'] },
      { emoji: '🚛', name: 'articulated lorry', keywords: ['semi', 'truck'] },
      { emoji: '🚜', name: 'tractor', keywords: ['farm'] },
      { emoji: '🦯', name: 'white cane', keywords: ['blind', 'accessibility'] },
      { emoji: '🛴', name: 'kick scooter', keywords: ['scooter'] },
      { emoji: '🚲', name: 'bicycle', keywords: ['bike', 'cycle'] },
      { emoji: '🛵', name: 'motor scooter', keywords: ['vespa', 'scooter'] },
      { emoji: '🏍️', name: 'motorcycle', keywords: ['motorbike', 'harley'] },
      { emoji: '🛺', name: 'auto rickshaw', keywords: ['tuk tuk', 'auto', 'rickshaw'] },
      { emoji: '🚨', name: 'police car light', keywords: ['siren', 'emergency', 'alert', 'warning'] },
      { emoji: '🚔', name: 'oncoming police car', keywords: ['police', 'cop'] },
      { emoji: '🚍', name: 'oncoming bus', keywords: ['bus'] },
      { emoji: '🚘', name: 'oncoming automobile', keywords: ['car'] },
      { emoji: '🚖', name: 'oncoming taxi', keywords: ['taxi'] },
      { emoji: '🚡', name: 'aerial tramway', keywords: ['cable car'] },
      { emoji: '🚠', name: 'mountain cableway', keywords: ['gondola'] },
      { emoji: '🚟', name: 'suspension railway', keywords: ['rail'] },
      { emoji: '🚃', name: 'railway car', keywords: ['train', 'tram'] },
      { emoji: '🚋', name: 'tram car', keywords: ['tram'] },
      { emoji: '🚞', name: 'mountain railway', keywords: ['train'] },
      { emoji: '🚝', name: 'monorail', keywords: ['train'] },
      { emoji: '🚄', name: 'high-speed train', keywords: ['bullet train', 'shinkansen'] },
      { emoji: '🚅', name: 'bullet train', keywords: ['train', 'fast'] },
      { emoji: '🚈', name: 'light rail', keywords: ['train'] },
      { emoji: '🚂', name: 'locomotive', keywords: ['steam train'] },
      { emoji: '🚆', name: 'train', keywords: ['railway', 'commute'] },
      { emoji: '🚇', name: 'metro', keywords: ['subway', 'tube'] },
      { emoji: '🚊', name: 'tram', keywords: ['tram'] },
      { emoji: '🚉', name: 'station', keywords: ['train station'] },
      { emoji: '🚁', name: 'helicopter', keywords: ['chopper'] },
      { emoji: '🛩️', name: 'small airplane', keywords: ['plane'] },
      { emoji: '✈️', name: 'airplane', keywords: ['plane', 'flight', 'travel', 'vacation'] },
      { emoji: '🛫', name: 'airplane departure', keywords: ['takeoff', 'departure'] },
      { emoji: '🛬', name: 'airplane arrival', keywords: ['landing', 'arrival'] },
      { emoji: '🪂', name: 'parachute', keywords: ['skydiving'] },
      { emoji: '💺', name: 'seat', keywords: ['chair', 'flight'] },
      { emoji: '🛰️', name: 'satellite', keywords: ['space', 'orbit'] },
      { emoji: '🚀', name: 'rocket', keywords: ['space', 'launch', 'startup', 'fast', 'moon'] },
      { emoji: '🛸', name: 'flying saucer', keywords: ['ufo', 'alien'] },
      { emoji: '🛶', name: 'canoe', keywords: ['boat', 'paddle'] },
      { emoji: '⛵', name: 'sailboat', keywords: ['boat', 'sailing', 'sea'] },
      { emoji: '🚤', name: 'speedboat', keywords: ['boat', 'fast'] },
      { emoji: '🛥️', name: 'motor boat', keywords: ['yacht'] },
      { emoji: '🛳️', name: 'passenger ship', keywords: ['cruise', 'ship'] },
      { emoji: '⛴️', name: 'ferry', keywords: ['ferry', 'boat'] },
      { emoji: '🚢', name: 'ship', keywords: ['boat', 'cargo'] },
      { emoji: '⚓', name: 'anchor', keywords: ['ship', 'harbor'] },
      { emoji: '⛽', name: 'fuel pump', keywords: ['gas', 'petrol'] },
      { emoji: '🚧', name: 'construction', keywords: ['warning', 'building'] },
      { emoji: '🚥', name: 'horizontal traffic light', keywords: ['traffic'] },
      { emoji: '🚦', name: 'vertical traffic light', keywords: ['traffic', 'stop'] },
      { emoji: '🚏', name: 'bus stop', keywords: ['bus'] },
      { emoji: '🗺️', name: 'world map', keywords: ['travel', 'geography'] },
      { emoji: '🗿', name: 'moai', keywords: ['statue', 'easter island'] },
      { emoji: '🗽', name: 'Statue of Liberty', keywords: ['new york', 'usa'] },
      { emoji: '🗼', name: 'Tokyo tower', keywords: ['tokyo', 'japan'] },
      { emoji: '🏰', name: 'castle', keywords: ['fairy tale', 'disney'] },
      { emoji: '🏯', name: 'Japanese castle', keywords: ['castle'] },
      { emoji: '🏟️', name: 'stadium', keywords: ['arena', 'sports'] },
      { emoji: '🎡', name: 'ferris wheel', keywords: ['carnival', 'amusement park'] },
      { emoji: '🎢', name: 'roller coaster', keywords: ['amusement park'] },
      { emoji: '🎠', name: 'carousel horse', keywords: ['carnival'] },
      { emoji: '⛲', name: 'fountain', keywords: ['water'] },
      { emoji: '🏖️', name: 'beach with umbrella', keywords: ['beach', 'vacation', 'summer'] },
      { emoji: '🏝️', name: 'desert island', keywords: ['island', 'tropical'] },
      { emoji: '🏜️', name: 'desert', keywords: ['sand', 'dry'] },
      { emoji: '🌋', name: 'volcano', keywords: ['lava', 'eruption'] },
      { emoji: '⛰️', name: 'mountain', keywords: ['hiking', 'nature'] },
      { emoji: '🏔️', name: 'snow-capped mountain', keywords: ['alps', 'snow'] },
      { emoji: '🏕️', name: 'camping', keywords: ['tent', 'outdoors'] },
      { emoji: '⛺', name: 'tent', keywords: ['camp'] },
      { emoji: '🏠', name: 'house', keywords: ['home', 'building'] },
      { emoji: '🏡', name: 'house with garden', keywords: ['home', 'suburb'] },
      { emoji: '🏘️', name: 'houses', keywords: ['neighborhood'] },
      { emoji: '🏢', name: 'office building', keywords: ['work', 'company', 'office'] },
      { emoji: '🏬', name: 'department store', keywords: ['mall', 'shopping'] },
      { emoji: '🏣', name: 'Japanese post office', keywords: ['mail'] },
      { emoji: '🏤', name: 'post office', keywords: ['mail'] },
      { emoji: '🏥', name: 'hospital', keywords: ['doctor', 'health'] },
      { emoji: '🏦', name: 'bank', keywords: ['money', 'finance'] },
      { emoji: '🏨', name: 'hotel', keywords: ['travel', 'vacation'] },
      { emoji: '🏪', name: 'convenience store', keywords: ['shop', '7-eleven'] },
      { emoji: '🏫', name: 'school', keywords: ['education', 'college'] },
      { emoji: '🏛️', name: 'classical building', keywords: ['museum', 'bank'] },
      { emoji: '⛪', name: 'church', keywords: ['religion', 'christian'] },
      { emoji: '🕌', name: 'mosque', keywords: ['religion', 'islam', 'muslim'] },
      { emoji: '🛕', name: 'hindu temple', keywords: ['mandir', 'hindu', 'temple'] },
      { emoji: '🕍', name: 'synagogue', keywords: ['jewish', 'religion'] },
      { emoji: '⛩️', name: 'shinto shrine', keywords: ['japan', 'torii'] },
      { emoji: '🕋', name: 'kaaba', keywords: ['mecca', 'hajj'] },
    ],
  },
  {
    id: 'activities',
    name: 'Activities',
    icon: '⚽',
    emojis: [
      { emoji: '⚽', name: 'soccer ball', keywords: ['football', 'soccer', 'sports'] },
      { emoji: '🏀', name: 'basketball', keywords: ['nba', 'ball', 'sports'] },
      { emoji: '🏈', name: 'american football', keywords: ['nfl', 'sports'] },
      { emoji: '⚾', name: 'baseball', keywords: ['mlb', 'sports'] },
      { emoji: '🥎', name: 'softball', keywords: ['sports'] },
      { emoji: '🎾', name: 'tennis', keywords: ['tennis', 'ball', 'racket'] },
      { emoji: '🏐', name: 'volleyball', keywords: ['sports'] },
      { emoji: '🏉', name: 'rugby football', keywords: ['rugby'] },
      { emoji: '🥏', name: 'flying disc', keywords: ['frisbee'] },
      { emoji: '🎱', name: 'pool 8 ball', keywords: ['billiards', 'pool', '8ball'] },
      { emoji: '🪀', name: 'yo-yo', keywords: ['toy'] },
      { emoji: '🏓', name: 'ping pong', keywords: ['table tennis'] },
      { emoji: '🏸', name: 'badminton', keywords: ['badminton'] },
      { emoji: '🏒', name: 'ice hockey', keywords: ['nhl', 'hockey'] },
      { emoji: '🏑', name: 'field hockey', keywords: ['hockey'] },
      { emoji: '🥍', name: 'lacrosse', keywords: ['sports'] },
      { emoji: '🏏', name: 'cricket game', keywords: ['cricket', 'ipl', 'bat', 'ball'] },
      { emoji: '🪃', name: 'boomerang', keywords: ['australia'] },
      { emoji: '🥅', name: 'goal net', keywords: ['soccer', 'hockey'] },
      { emoji: '⛳', name: 'flag in hole', keywords: ['golf'] },
      { emoji: '🪁', name: 'kite', keywords: ['flying'] },
      { emoji: '🏹', name: 'bow and arrow', keywords: ['archery'] },
      { emoji: '🎣', name: 'fishing pole', keywords: ['fish'] },
      { emoji: '🤿', name: 'diving mask', keywords: ['snorkeling', 'scuba'] },
      { emoji: '🥊', name: 'boxing glove', keywords: ['boxing', 'fight'] },
      { emoji: '🥋', name: 'martial arts uniform', keywords: ['karate', 'judo', 'taekwondo'] },
      { emoji: '🎽', name: 'running shirt', keywords: ['marathon'] },
      { emoji: '🛹', name: 'skateboard', keywords: ['skate'] },
      { emoji: '🛼', name: 'roller skate', keywords: ['skate'] },
      { emoji: '🛷', name: 'sled', keywords: ['winter'] },
      { emoji: '⛸️', name: 'ice skate', keywords: ['skating'] },
      { emoji: '🥌', name: 'curling stone', keywords: ['olympics'] },
      { emoji: '🎿', name: 'skis', keywords: ['skiing', 'snow'] },
      { emoji: '🏂', name: 'snowboarder', keywords: ['snowboard'] },
      { emoji: '🏋️', name: 'person lifting weights', keywords: ['gym', 'workout', 'weights', 'fitness'] },
      { emoji: '🤼', name: 'people wrestling', keywords: ['wrestling'] },
      { emoji: '🤸', name: 'person cartwheeling', keywords: ['gymnastics'] },
      { emoji: '⛹️', name: 'person bouncing ball', keywords: ['basketball'] },
      { emoji: '🤺', name: 'person fencing', keywords: ['fencing'] },
      { emoji: '🤾', name: 'person playing handball', keywords: ['handball'] },
      { emoji: '🏌️', name: 'person golfing', keywords: ['golf'] },
      { emoji: '🏇', name: 'horse racing', keywords: ['jockey'] },
      { emoji: '🧘', name: 'person in lotus position', keywords: ['yoga', 'meditation', 'zen'] },
      { emoji: '🏄', name: 'person surfing', keywords: ['surf', 'waves', 'ocean'] },
      { emoji: '🏊', name: 'person swimming', keywords: ['swim', 'pool'] },
      { emoji: '🤽', name: 'person playing water polo', keywords: ['water polo'] },
      { emoji: '🚣', name: 'person rowing boat', keywords: ['rowing', 'boat'] },
      { emoji: '🧗', name: 'person climbing', keywords: ['climbing', 'bouldering'] },
      { emoji: '🚵', name: 'person mountain biking', keywords: ['bike'] },
      { emoji: '🚴', name: 'person biking', keywords: ['cycling'] },
      { emoji: '🏆', name: 'trophy', keywords: ['winner', 'champion', 'first', 'prize'] },
      { emoji: '🥇', name: '1st place medal', keywords: ['gold', 'first', 'winner'] },
      { emoji: '🥈', name: '2nd place medal', keywords: ['silver', 'second'] },
      { emoji: '🥉', name: '3rd place medal', keywords: ['bronze', 'third'] },
      { emoji: '🏅', name: 'sports medal', keywords: ['medal'] },
      { emoji: '🎖️', name: 'military medal', keywords: ['honor'] },
      { emoji: '🎫', name: 'ticket', keywords: ['event', 'pass'] },
      { emoji: '🎟️', name: 'admission tickets', keywords: ['cinema', 'raffle'] },
      { emoji: '🎪', name: 'circus tent', keywords: ['carnival'] },
      { emoji: '🤹', name: 'person juggling', keywords: ['juggler'] },
      { emoji: '🎭', name: 'performing arts', keywords: ['theater', 'drama', 'acting'] },
      { emoji: '🩰', name: 'ballet shoes', keywords: ['dance'] },
      { emoji: '🎨', name: 'artist palette', keywords: ['art', 'paint', 'design', 'creative'] },
      { emoji: '🎬', name: 'clapper board', keywords: ['movie', 'film', 'cinema'] },
      { emoji: '🎤', name: 'microphone', keywords: ['sing', 'karaoke', 'music'] },
      { emoji: '🎧', name: 'headphone', keywords: ['music', 'listen', 'audio'] },
      { emoji: '🎼', name: 'musical score', keywords: ['music', 'notes'] },
      { emoji: '🎹', name: 'musical keyboard', keywords: ['piano', 'instrument'] },
      { emoji: '🥁', name: 'drum', keywords: ['beats', 'music'] },
      { emoji: '🪘', name: 'long drum', keywords: ['percussion'] },
      { emoji: '🎷', name: 'saxophone', keywords: ['jazz', 'music'] },
      { emoji: '🎺', name: 'trumpet', keywords: ['brass', 'music'] },
      { emoji: '🪗', name: 'accordion', keywords: ['music'] },
      { emoji: '🎸', name: 'guitar', keywords: ['rock', 'acoustic', 'instrument', 'music'] },
      { emoji: '🪕', name: 'banjo', keywords: ['music'] },
      { emoji: '🎻', name: 'violin', keywords: ['classical', 'instrument'] },
      { emoji: '🎲', name: 'game die', keywords: ['dice', 'gamble', 'board game'] },
      { emoji: '♟️', name: 'chess pawn', keywords: ['chess', 'strategy'] },
      { emoji: '🎯', name: 'bullseye', keywords: ['target', 'goal', 'accurate', 'darts'] },
      { emoji: '🎳', name: 'bowling', keywords: ['strike', 'game'] },
      { emoji: '🎮', name: 'video game', keywords: ['gaming', 'controller', 'playstation', 'xbox'] },
      { emoji: '🎰', name: 'slot machine', keywords: ['casino', 'jackpot'] },
      { emoji: '🧩', name: 'puzzle piece', keywords: ['puzzle', 'jigsaw'] },
    ],
  },
  {
    id: 'objects',
    name: 'Objects',
    icon: '💡',
    emojis: [
      { emoji: '📱', name: 'mobile phone', keywords: ['iphone', 'smartphone', 'cell'] },
      { emoji: '📲', name: 'mobile phone with arrow', keywords: ['call', 'message'] },
      { emoji: '💻', name: 'laptop', keywords: ['computer', 'macbook', 'pc', 'work', 'code'] },
      { emoji: '⌨️', name: 'keyboard', keywords: ['type', 'computer'] },
      { emoji: '🖥️', name: 'desktop computer', keywords: ['monitor', 'screen'] },
      { emoji: '🖨️', name: 'printer', keywords: ['paper'] },
      { emoji: '🖱️', name: 'computer mouse', keywords: ['click'] },
      { emoji: '🖲️', name: 'trackball', keywords: ['cursor'] },
      { emoji: '🕹️', name: 'joystick', keywords: ['game', 'arcade'] },
      { emoji: '🗜️', name: 'clamp', keywords: ['tool'] },
      { emoji: '💽', name: 'computer disk', keywords: ['minidisc'] },
      { emoji: '💾', name: 'floppy disk', keywords: ['save', 'retro'] },
      { emoji: '💿', name: 'optical disk', keywords: ['cd', 'dvd'] },
      { emoji: '📀', name: 'dvd', keywords: ['movie', 'disc'] },
      { emoji: '📷', name: 'camera', keywords: ['photo', 'picture'] },
      { emoji: '📸', name: 'camera with flash', keywords: ['photography', 'snapshot'] },
      { emoji: '📹', name: 'video camera', keywords: ['film', 'record'] },
      { emoji: '🎥', name: 'movie camera', keywords: ['cinema'] },
      { emoji: '📽️', name: 'film projector', keywords: ['movie'] },
      { emoji: '🎞️', name: 'film frames', keywords: ['movie'] },
      { emoji: '📞', name: 'telephone receiver', keywords: ['call', 'phone'] },
      { emoji: '☎️', name: 'telephone', keywords: ['landline', 'call'] },
      { emoji: '📟', name: 'pager', keywords: ['beeper'] },
      { emoji: '📠', name: 'fax machine', keywords: ['fax'] },
      { emoji: '📺', name: 'television', keywords: ['tv', 'screen'] },
      { emoji: '📻', name: 'radio', keywords: ['broadcast'] },
      { emoji: '🎙️', name: 'studio microphone', keywords: ['podcast', 'recording'] },
      { emoji: '⏱️', name: 'stopwatch', keywords: ['time', 'timer'] },
      { emoji: '⏲️', name: 'timer clock', keywords: ['timer'] },
      { emoji: '⏰', name: 'alarm clock', keywords: ['wake up', 'morning', 'alarm'] },
      { emoji: '🕰️', name: 'mantelpiece clock', keywords: ['antique'] },
      { emoji: '⌛', name: 'hourglass done', keywords: ['time'] },
      { emoji: '⏳', name: 'hourglass not done', keywords: ['loading', 'wait', 'time'] },
      { emoji: '📡', name: 'satellite antenna', keywords: ['dish', 'broadcast'] },
      { emoji: '🔋', name: 'battery', keywords: ['energy', 'power', 'charge'] },
      { emoji: '🪫', name: 'low battery', keywords: ['dead', 'empty'] },
      { emoji: '🔌', name: 'electric plug', keywords: ['power', 'cord'] },
      { emoji: '💡', name: 'light bulb', keywords: ['idea', 'bright', 'smart', 'creativity'] },
      { emoji: '🔦', name: 'flashlight', keywords: ['torch', 'light'] },
      { emoji: '🕯️', name: 'candle', keywords: ['flame', 'light'] },
      { emoji: '🪔', name: 'diya lamp', keywords: ['diwali', 'lamp', 'oil'] },
      { emoji: '🧯', name: 'fire extinguisher', keywords: ['safety'] },
      { emoji: '💸', name: 'money with wings', keywords: ['cash', 'rich', 'spend', 'dollar'] },
      { emoji: '💵', name: 'dollar banknote', keywords: ['money', 'cash', 'usd'] },
      { emoji: '💴', name: 'yen banknote', keywords: ['money', 'japan'] },
      { emoji: '💶', name: 'euro banknote', keywords: ['money', 'europe'] },
      { emoji: '💷', name: 'pound banknote', keywords: ['money', 'uk'] },
      { emoji: '🪙', name: 'coin', keywords: ['crypto', 'money', 'gold'] },
      { emoji: '💰', name: 'money bag', keywords: ['rich', 'wealth', 'cash'] },
      { emoji: '💳', name: 'credit card', keywords: ['payment', 'visa', 'mastercard', 'shopping'] },
      { emoji: '💎', name: 'gem stone', keywords: ['diamond', 'jewelry', 'valuable'] },
      { emoji: '⚖️', name: 'balance scale', keywords: ['justice', 'law', 'legal'] },
      { emoji: '🪜', name: 'ladder', keywords: ['climb'] },
      { emoji: '🧰', name: 'toolbox', keywords: ['tools', 'fix'] },
      { emoji: '🪛', name: 'screwdriver', keywords: ['tool'] },
      { emoji: '🔧', name: 'wrench', keywords: ['fix', 'repair', 'tools', 'settings'] },
      { emoji: '🔨', name: 'hammer', keywords: ['build', 'tool'] },
      { emoji: '⚒️', name: 'hammer and pick', keywords: ['mining', 'tools'] },
      { emoji: '🛠️', name: 'hammer and wrench', keywords: ['dev', 'build', 'tools', 'settings'] },
      { emoji: '⛏️', name: 'pick', keywords: ['minecraft', 'mine'] },
      { emoji: '🪚', name: 'carpentry saw', keywords: ['saw', 'wood'] },
      { emoji: '🔩', name: 'nut and bolt', keywords: ['hardware'] },
      { emoji: '⚙️', name: 'gear', keywords: ['settings', 'config', 'cog', 'mechanical'] },
      { emoji: '🧱', name: 'brick', keywords: ['wall', 'build'] },
      { emoji: '⛓️', name: 'chains', keywords: ['blockchain', 'link'] },
      { emoji: '🧲', name: 'magnet', keywords: ['attract'] },
      { emoji: '🔫', name: 'water pistol', keywords: ['gun', 'squirt gun'] },
      { emoji: '💣', name: 'bomb', keywords: ['explode', 'boom'] },
      { emoji: '🧨', name: 'firecracker', keywords: ['dynamite', 'celebrate'] },
      { emoji: '🪓', name: 'axe', keywords: ['chop', 'wood'] },
      { emoji: '🔪', name: 'kitchen knife', keywords: ['chef', 'cook', 'cut'] },
      { emoji: '🗡️', name: 'dagger', keywords: ['sword', 'weapon'] },
      { emoji: '⚔️', name: 'crossed swords', keywords: ['battle', 'fight'] },
      { emoji: '🛡️', name: 'shield', keywords: ['security', 'protect', 'defense'] },
      { emoji: '🔮', name: 'crystal ball', keywords: ['magic', 'fortune'] },
      { emoji: '🧿', name: 'nazar amulet', keywords: ['evil eye', 'protection'] },
      { emoji: '💊', name: 'pill', keywords: ['medicine', 'drug', 'pharmacy'] },
      { emoji: '💉', name: 'syringe', keywords: ['vaccine', 'injection', 'blood'] },
      { emoji: '🩸', name: 'drop of blood', keywords: ['donate', 'blood'] },
      { emoji: '🧬', name: 'dna', keywords: ['genetics', 'biology', 'science'] },
      { emoji: '🔬', name: 'microscope', keywords: ['science', 'research', 'lab'] },
      { emoji: '🔭', name: 'telescope', keywords: ['space', 'astronomy', 'stars'] },
      { emoji: '🩹', name: 'adhesive bandage', keywords: ['bandaid', 'heal'] },
      { emoji: '🩺', name: 'stethoscope', keywords: ['doctor', 'medical'] },
      { emoji: '🗝️', name: 'old key', keywords: ['secret', 'key'] },
      { emoji: '🔑', name: 'key', keywords: ['password', 'unlock', 'security', 'access'] },
      { emoji: '🔐', name: 'locked with key', keywords: ['security'] },
      { emoji: '🔏', name: 'locked with pen', keywords: ['privacy'] },
      { emoji: '🔒', name: 'locked', keywords: ['secure', 'private', 'lock'] },
      { emoji: '🔓', name: 'unlocked', keywords: ['open', 'public'] },
      { emoji: '✉️', name: 'envelope', keywords: ['email', 'letter', 'mail'] },
      { emoji: '📩', name: 'envelope with arrow', keywords: ['inbox', 'received'] },
      { emoji: '📨', name: 'incoming envelope', keywords: ['mail'] },
      { emoji: '📧', name: 'e-mail', keywords: ['email', 'letter'] },
      { emoji: '💌', name: 'love letter', keywords: ['heart', 'letter'] },
      { emoji: '📦', name: 'package', keywords: ['parcel', 'box', 'delivery', 'amazon'] },
      { emoji: '🏷️', name: 'label', keywords: ['tag', 'price'] },
      { emoji: '📜', name: 'scroll', keywords: ['ancient', 'document'] },
      { emoji: '📄', name: 'page facing up', keywords: ['document', 'file', 'paper'] },
      { emoji: '📑', name: 'bookmark tabs', keywords: ['tabs', 'organize'] },
      { emoji: '🧾', name: 'receipt', keywords: ['bill', 'accounting'] },
      { emoji: '📊', name: 'bar chart', keywords: ['stats', 'analytics', 'growth', 'graph'] },
      { emoji: '📈', name: 'chart increasing', keywords: ['up', 'growth', 'stocks', 'profit', 'success'] },
      { emoji: '📉', name: 'chart decreasing', keywords: ['down', 'loss', 'decline'] },
      { emoji: '🗒️', name: 'spiral notepad', keywords: ['note', 'memo'] },
      { emoji: '🗓️', name: 'spiral calendar', keywords: ['date', 'schedule'] },
      { emoji: '📆', name: 'tear-off calendar', keywords: ['calendar', 'date'] },
      { emoji: '📅', name: 'calendar', keywords: ['schedule', 'event', 'date', 'meeting'] },
      { emoji: '📋', name: 'clipboard', keywords: ['checklist', 'copy', 'tasks'] },
      { emoji: '📁', name: 'file folder', keywords: ['directory', 'files'] },
      { emoji: '📂', name: 'open file folder', keywords: ['directory'] },
      { emoji: '🗂️', name: 'card index dividers', keywords: ['archive'] },
      { emoji: '🗞️', name: 'rolled-up newspaper', keywords: ['news', 'press'] },
      { emoji: '📰', name: 'newspaper', keywords: ['news', 'headline'] },
      { emoji: '📓', name: 'notebook', keywords: ['journal', 'notes'] },
      { emoji: '📕', name: 'closed book', keywords: ['book', 'read'] },
      { emoji: '📗', name: 'green book', keywords: ['book'] },
      { emoji: '📘', name: 'blue book', keywords: ['book'] },
      { emoji: '📙', name: 'orange book', keywords: ['book'] },
      { emoji: '📚', name: 'books', keywords: ['library', 'study', 'education', 'reading'] },
      { emoji: '📖', name: 'open book', keywords: ['read', 'study'] },
      { emoji: '🔖', name: 'bookmark', keywords: ['save', 'mark'] },
      { emoji: '🔗', name: 'link', keywords: ['url', 'hyperlink', 'chain'] },
      { emoji: '📎', name: 'paperclip', keywords: ['attachment', 'attach', 'file'] },
      { emoji: '🖇️', name: 'linked paperclips', keywords: ['attachment'] },
      { emoji: '📌', name: 'pushpin', keywords: ['pin', 'pinned', 'important'] },
      { emoji: '📍', name: 'round pushpin', keywords: ['location', 'map', 'pin'] },
      { emoji: '✂️', name: 'scissors', keywords: ['cut', 'snip'] },
      { emoji: '🖊️', name: 'pen', keywords: ['write', 'ink'] },
      { emoji: '🖋️', name: 'fountain pen', keywords: ['signature', 'write'] },
      { emoji: '✒️', name: 'black nib', keywords: ['calligraphy'] },
      { emoji: '📝', name: 'memo', keywords: ['note', 'write', 'pencil', 'edit'] },
      { emoji: '✏️', name: 'pencil', keywords: ['draw', 'write', 'edit'] },
      { emoji: '🔍', name: 'magnifying glass tilted left', keywords: ['search', 'find', 'zoom', 'lookup'] },
      { emoji: '🔎', name: 'magnifying glass tilted right', keywords: ['search', 'find'] },
      { emoji: '🎁', name: 'wrapped gift', keywords: ['present', 'birthday', 'christmas', 'surprise'] },
    ],
  },
  {
    id: 'symbols',
    name: 'Symbols',
    icon: '❤️',
    emojis: [
      { emoji: '❤️', name: 'red heart', keywords: ['love', 'like', 'heart', 'romance'] },
      { emoji: '🧡', name: 'orange heart', keywords: ['love', 'orange', 'sahaj'] },
      { emoji: '💛', name: 'yellow heart', keywords: ['love', 'friendship'] },
      { emoji: '💚', name: 'green heart', keywords: ['love', 'nature', 'healthy'] },
      { emoji: '💙', name: 'blue heart', keywords: ['love', 'peace', 'blue'] },
      { emoji: '💜', name: 'purple heart', keywords: ['love', 'purple'] },
      { emoji: '🖤', name: 'black heart', keywords: ['love', 'dark', 'black'] },
      { emoji: '🤍', name: 'white heart', keywords: ['love', 'pure', 'white'] },
      { emoji: '🤎', name: 'brown heart', keywords: ['love', 'brown'] },
      { emoji: '💔', name: 'broken heart', keywords: ['heartbreak', 'sad', 'breakup'] },
      { emoji: '❣️', name: 'heart exclamation', keywords: ['love', 'exclamation'] },
      { emoji: '💕', name: 'two hearts', keywords: ['love', 'hearts'] },
      { emoji: '💞', name: 'revolving hearts', keywords: ['love'] },
      { emoji: '💓', name: 'beating heart', keywords: ['heartbeat', 'love'] },
      { emoji: '💗', name: 'growing heart', keywords: ['love', 'sweet'] },
      { emoji: '💖', name: 'sparkling heart', keywords: ['sparkle', 'love', 'shine'] },
      { emoji: '💘', name: 'heart with arrow', keywords: ['cupid', 'love'] },
      { emoji: '💝', name: 'heart with ribbon', keywords: ['gift', 'love'] },
      { emoji: '💟', name: 'heart decoration', keywords: ['purple'] },
      { emoji: '☮️', name: 'peace symbol', keywords: ['peace', 'hippie'] },
      { emoji: '✝️', name: 'latin cross', keywords: ['christian', 'cross'] },
      { emoji: '☪️', name: 'star and crescent', keywords: ['islam', 'muslim'] },
      { emoji: '🕉️', name: 'om', keywords: ['hindu', 'om', 'sacred', 'yoga'] },
      { emoji: '☸️', name: 'wheel of dharma', keywords: ['buddhist'] },
      { emoji: '✡️', name: 'star of David', keywords: ['jewish'] },
      { emoji: '🔯', name: 'dotted six-pointed star', keywords: ['fortune'] },
      { emoji: '🕎', name: 'menorah', keywords: ['hanukkah'] },
      { emoji: '☯️', name: 'yin yang', keywords: ['balance', 'zen'] },
      { emoji: '☦️', name: 'orthodox cross', keywords: ['cross'] },
      { emoji: '🛐', name: 'place of worship', keywords: ['worship'] },
      { emoji: '⛎', name: 'Ophiuchus', keywords: ['zodiac'] },
      { emoji: '♈', name: 'Aries', keywords: ['zodiac'] },
      { emoji: '♉', name: 'Taurus', keywords: ['zodiac'] },
      { emoji: '♊', name: 'Gemini', keywords: ['zodiac'] },
      { emoji: '♋', name: 'Cancer', keywords: ['zodiac'] },
      { emoji: '♌', name: 'Leo', keywords: ['zodiac'] },
      { emoji: '♍', name: 'Virgo', keywords: ['zodiac'] },
      { emoji: '♎', name: 'Libra', keywords: ['zodiac'] },
      { emoji: '♏', name: 'Scorpio', keywords: ['zodiac'] },
      { emoji: '♐', name: 'Sagittarius', keywords: ['zodiac'] },
      { emoji: '♑', name: 'Capricorn', keywords: ['zodiac'] },
      { emoji: '♒', name: 'Aquarius', keywords: ['zodiac'] },
      { emoji: '♓', name: 'Pisces', keywords: ['zodiac'] },
      { emoji: '💯', name: 'hundred points', keywords: ['100', 'perfect', 'score', 'keep it 100', 'agree'] },
      { emoji: '💢', name: 'anger symbol', keywords: ['mad', 'anime'] },
      { emoji: '💥', name: 'collision', keywords: ['boom', 'explode', 'impact'] },
      { emoji: '💫', name: 'dizzy', keywords: ['stars', 'sparkle'] },
      { emoji: '💦', name: 'sweat droplets', keywords: ['water', 'splash', 'drip'] },
      { emoji: '💨', name: 'dashing away', keywords: ['fast', 'speed', 'run'] },
      { emoji: '🕳️', name: 'hole', keywords: ['void'] },
      { emoji: '💣', name: 'bomb', keywords: ['boom'] },
      { emoji: '💬', name: 'speech balloon', keywords: ['chat', 'message', 'comment', 'talk'] },
      { emoji: '👁️‍🗨️', name: 'eye in speech bubble', keywords: ['witness'] },
      { emoji: '🗨️', name: 'left speech bubble', keywords: ['talk'] },
      { emoji: '🗯️', name: 'right anger bubble', keywords: ['yell', 'shout'] },
      { emoji: '💭', name: 'thought balloon', keywords: ['think', 'dream'] },
      { emoji: '💤', name: 'zzz', keywords: ['sleep', 'tired', 'snore'] },
      { emoji: '🔥', name: 'fire', keywords: ['hot', 'lit', 'flame', 'trend', 'fire', 'awesome'] },
      { emoji: '⭐', name: 'star', keywords: ['star', 'favorite', 'rating', 'gold'] },
      { emoji: '🌟', name: 'glowing star', keywords: ['sparkle', 'star', 'shine'] },
      { emoji: '✨', name: 'sparkles', keywords: ['magic', 'shine', 'special', 'clean', 'ai'] },
      { emoji: '⚡', name: 'high voltage', keywords: ['lightning', 'fast', 'power', 'bolt', 'electric'] },
      { emoji: '🎉', name: 'party popper', keywords: ['celebrate', 'congrats', 'party', 'birthday', 'yay'] },
      { emoji: '🎊', name: 'confetti ball', keywords: ['celebration', 'party'] },
      { emoji: '🎈', name: 'balloon', keywords: ['birthday', 'party'] },
      { emoji: '⚠️', name: 'warning', keywords: ['caution', 'alert', 'danger'] },
      { emoji: '⛔', name: 'no entry', keywords: ['stop', 'forbidden'] },
      { emoji: '🚫', name: 'prohibited', keywords: ['no', 'forbidden'] },
      { emoji: '❌', name: 'cross mark', keywords: ['no', 'wrong', 'cancel', 'x'] },
      { emoji: '⭕', name: 'hollow red circle', keywords: ['correct', 'circle'] },
      { emoji: '🛑', name: 'stop sign', keywords: ['stop', 'halt'] },
      { emoji: '✅', name: 'check mark button', keywords: ['yes', 'correct', 'done', 'approved', 'pass'] },
      { emoji: '✔️', name: 'check mark', keywords: ['check', 'done'] },
      { emoji: '❓', name: 'question mark', keywords: ['what', 'help', 'doubt'] },
      { emoji: '❔', name: 'white question mark', keywords: ['question'] },
      { emoji: '❕', name: 'white exclamation mark', keywords: ['exclamation'] },
      { emoji: '❗', name: 'exclamation mark', keywords: ['important', 'alert', 'attention'] },
      { emoji: '‼️', name: 'double exclamation mark', keywords: ['loud', 'critical'] },
      { emoji: '⁉️', name: 'exclamation question mark', keywords: ['surprise'] },
      { emoji: '🔴', name: 'red circle', keywords: ['dot', 'circle'] },
      { emoji: '🟠', name: 'orange circle', keywords: ['dot', 'circle', 'sahaj'] },
      { emoji: '🟡', name: 'yellow circle', keywords: ['dot', 'circle'] },
      { emoji: '🟢', name: 'green circle', keywords: ['online', 'active', 'dot'] },
      { emoji: '🔵', name: 'blue circle', keywords: ['dot', 'circle'] },
      { emoji: '🟣', name: 'purple circle', keywords: ['dot', 'circle'] },
      { emoji: '🟤', name: 'brown circle', keywords: ['dot', 'circle'] },
      { emoji: '⚫', name: 'black circle', keywords: ['dot', 'circle'] },
      { emoji: '⚪', name: 'white circle', keywords: ['dot', 'circle'] },
      { emoji: '🟦', name: 'blue square', keywords: ['square'] },
      { emoji: '🟧', name: 'orange square', keywords: ['square'] },
      { emoji: '🟩', name: 'green square', keywords: ['square'] },
      { emoji: '🟨', name: 'yellow square', keywords: ['square'] },
      { emoji: '🟥', name: 'red square', keywords: ['square'] },
      { emoji: '🟪', name: 'purple square', keywords: ['square'] },
      { emoji: '⬛', name: 'black large square', keywords: ['square'] },
      { emoji: '⬜', name: 'white large square', keywords: ['square'] },
    ],
  },
  {
    id: 'flags',
    name: 'Flags',
    icon: '🚩',
    emojis: [
      { emoji: '🏁', name: 'chequered flag', keywords: ['race', 'finish'] },
      { emoji: '🚩', name: 'triangular flag', keywords: ['flag', 'post', 'red flag'] },
      { emoji: '🎌', name: 'crossed flags', keywords: ['japan', 'celebrate'] },
      { emoji: '🏴', name: 'black flag', keywords: ['flag'] },
      { emoji: '🏳️', name: 'white flag', keywords: ['surrender', 'peace'] },
      { emoji: '🏳️‍🌈', name: 'rainbow flag', keywords: ['pride', 'lgbtq'] },
      { emoji: '🏳️‍⚧️', name: 'transgender flag', keywords: ['trans'] },
      { emoji: '🏴‍☠️', name: 'pirate flag', keywords: ['jolly roger', 'skull'] },
      { emoji: '🇮🇳', name: 'flag: India', keywords: ['india', 'in', 'bharat', 'tricolor'] },
      { emoji: '🇺🇸', name: 'flag: United States', keywords: ['usa', 'us', 'america', 'stars and stripes'] },
      { emoji: '🇬🇧', name: 'flag: United Kingdom', keywords: ['uk', 'britain', 'england', 'union jack'] },
      { emoji: '🇨🇦', name: 'flag: Canada', keywords: ['canada', 'ca', 'maple'] },
      { emoji: '🇦🇺', name: 'flag: Australia', keywords: ['australia', 'au'] },
      { emoji: '🇩🇪', name: 'flag: Germany', keywords: ['germany', 'de', 'deutschland'] },
      { emoji: '🇫🇷', name: 'flag: France', keywords: ['france', 'fr', 'french'] },
      { emoji: '🇯🇵', name: 'flag: Japan', keywords: ['japan', 'jp', 'nippon'] },
      { emoji: '🇧🇷', name: 'flag: Brazil', keywords: ['brazil', 'br'] },
      { emoji: '🇨🇳', name: 'flag: China', keywords: ['china', 'cn'] },
      { emoji: '🇷🇺', name: 'flag: Russia', keywords: ['russia', 'ru'] },
      { emoji: '🇰🇷', name: 'flag: South Korea', keywords: ['korea', 'kr'] },
      { emoji: '🇮🇹', name: 'flag: Italy', keywords: ['italy', 'it'] },
      { emoji: '🇪🇸', name: 'flag: Spain', keywords: ['spain', 'es'] },
      { emoji: '🇲🇽', name: 'flag: Mexico', keywords: ['mexico', 'mx'] },
      { emoji: '🇳🇱', name: 'flag: Netherlands', keywords: ['netherlands', 'holland'] },
      { emoji: '🇸🇪', name: 'flag: Sweden', keywords: ['sweden', 'se'] },
      { emoji: '🇨🇭', name: 'flag: Switzerland', keywords: ['switzerland', 'swiss'] },
      { emoji: '🇸🇬', name: 'flag: Singapore', keywords: ['singapore', 'sg'] },
      { emoji: '🇦🇪', name: 'flag: United Arab Emirates', keywords: ['uae', 'dubai'] },
      { emoji: '🇸🇦', name: 'flag: Saudi Arabia', keywords: ['saudi'] },
      { emoji: '🇿🇦', name: 'flag: South Africa', keywords: ['south africa'] },
      { emoji: '🇳🇿', name: 'flag: New Zealand', keywords: ['new zealand', 'nz'] },
      { emoji: '🇮🇩', name: 'flag: Indonesia', keywords: ['indonesia', 'id'] },
      { emoji: '🇵🇰', name: 'flag: Pakistan', keywords: ['pakistan', 'pk'] },
      { emoji: '🇧🇩', name: 'flag: Bangladesh', keywords: ['bangladesh', 'bd'] },
      { emoji: '🇳🇵', name: 'flag: Nepal', keywords: ['nepal', 'np'] },
      { emoji: '🇱🇰', name: 'flag: Sri Lanka', keywords: ['sri lanka', 'lk'] },
      { emoji: '🇳🇬', name: 'flag: Nigeria', keywords: ['nigeria', 'ng'] },
      { emoji: '🇪🇬', name: 'flag: Egypt', keywords: ['egypt', 'eg'] },
      { emoji: '🇦🇷', name: 'flag: Argentina', keywords: ['argentina', 'ar'] },
    ],
  },
];

export const QUICK_REACTION_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🎉'];

const RECENT_STORAGE_KEY = 'sahaj_recent_emojis';
const DEFAULT_RECENTS = ['👍', '❤️', '🔥', '🎉', '🚀', '👀', '✨', '💯', '👏', '🙌', '😎', '💡', '✅', '❌'];

export function getRecentEmojis(): string[] {
  try {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return DEFAULT_RECENTS;
    const raw = window.localStorage?.getItem(RECENT_STORAGE_KEY);
    if (!raw) return DEFAULT_RECENTS;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : DEFAULT_RECENTS;
  } catch {
    return DEFAULT_RECENTS;
  }
}

export function saveRecentEmoji(emoji: string): string[] {
  try {
    const current = getRecentEmojis();
    const filtered = current.filter((e) => e !== emoji);
    const updated = [emoji, ...filtered].slice(0, 24);
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
      window.localStorage?.setItem(RECENT_STORAGE_KEY, JSON.stringify(updated));
    }
    return updated;
  } catch {
    return DEFAULT_RECENTS;
  }
}
